import React, { useState } from "react";
import { Avatar } from "antd";
import { Link, useHistory, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react";
import { InfoWraper, NavAuth, UserDropDwon } from "./auth-info-style";
import Message from "./message";
import Notification from "./notification";
import Settings from "./settings";
import Support from "./support";
import { Popover } from "../../popup/popup";
import { Dropdown } from "../../dropdown/dropdown";
import { logOut } from "../../../redux/authentication/actionCreator";
import Heading from "../../heading/heading";
import { setUserData } from "../../../redux/users/actionCreator";
import Text from "antd/lib/typography/Text";
import { apiRoutes } from "../../../config/dataService/apiRoutes";
import { ExtranetService } from "../../../config/dataService/userService";
import {
  addNotificationError,
  addNotificationSuccess,
} from "../../../utility/notifications";

const AuthInfo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    flag: "english",
  });
  const { flag } = state;

  const { userprofile } = useSelector((state) => {
    return {
      userprofile: state.userData,
      isLoading: true,
    };
  });
  const isAdmin = userprofile.data.isAdmin;
  const userId = userprofile.data.userId;

  const logoutApi = async (data) => {
    const body = {
      userId: userId,
    };
    try {
      const response = await ExtranetService.post(apiRoutes.users.logout, body);
      console.log("response.allLogDownloads: ", response.data);
      if (response.data) {
        await addNotificationSuccess("Vuelva Pronto");
      }
    } catch (err) {}
  };

  const SignOut = (e) => {
    logoutApi();
    e.preventDefault();
    dispatch(logOut());

    dispatch(setUserData({}));
    window.location.href = "/";
  };

  const seeProfile = (e) => {
    e.preventDefault();
    isAdmin === "yes"
      ? history.push("/admin/admin-profile")
      : history.push("/panel/admin-profile");
  };

  const items = [
    {
      key: "1",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.antgroup.com"
        >
          1st menu item
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.aliyun.com"
        >
          2nd menu item (disabled)
        </a>
      ),
      icon: <></>,
      disabled: true,
    },
  ];

  const userContent = (
    <div>
      <Link
        className="user-dropdwon__bottomAction"
        onClick={seeProfile}
        to={`/admin-profile`}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <FeatherIcon icon="user" /> Perfil
      </Link>
      <Link
        className="user-dropdwon__bottomAction"
        onClick={SignOut}
        to="#"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <FeatherIcon icon="log-out" /> Salir
      </Link>
    </div>
  );

  const onFlagChangeHandle = (value) => {
    setState({
      ...state,
      flag: value,
    });
  };

  const country = (
    <NavAuth>
      <Link onClick={() => onFlagChangeHandle("english")} to="#">
        <img src={require("../../../static/img/flag/english.png")} alt="" />
        <span>English</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle("germany")} to="#">
        <img src={require("../../../static/img/flag/germany.png")} alt="" />
        <span>Germany</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle("spain")} to="#">
        <img src={require("../../../static/img/flag/spain.png")} alt="" />
        <span>Spain</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle("turky")} to="#">
        <img src={require("../../../static/img/flag/turky.png")} alt="" />
        <span>Turky</span>
      </Link>
    </NavAuth>
  );

  return (
    <InfoWraper>
      <Message />
      {/* <Notification /> */}

      <Settings />
      <Support />
      <div className="nav-author">
        <Text style={{color:'white'}}>{userprofile.data.name}</Text>
      </div>

      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="head-example">
            <Avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
